export const initialTracks = [
  {
    url: '/music/Children of Bodom - In Your Face.mp3',
    duration: 256.176,
    metaData: { title: 'In Your Face', artist: 'Children of Bodom', album: 'Are You Dead Yet?' },
  },
  {
    url: '/music/Gojira - The art of dying.mp3',
    duration: 594.36,
    metaData: { title: 'The Art of Dying', artist: 'Gojira', album: 'The Way of All Flesh' },
  },
  {
    url: '/music/Infant Annihilator - Cuntcrusher.mp3',
    duration: 298.92,
    metaData: { title: 'Cuntcrusher', artist: 'Infant Annihilator', album: 'The Palpable Leprosy of Pollution' },
  },
  {
    url: '/music/Iron Maiden - Hallowed Be Thy Name.mp3',
    duration: 432.36,
    metaData: { title: 'Hallowed Be Thy Name', artist: 'Iron Maiden', album: 'The Number of the Beast' },
  },
  {
    url: '/music/Jim Croce - Time in a Bottle.mp3',
    duration: 146.856,
    metaData: { title: 'Time in a Bottle', artist: 'Jim Croce', album: 'Photographs & Memories: His Greatest Hits' },
  },
  {
    url: '/music/Joe Satriani - Starry Night.mp3',
    duration: 233.544,
    metaData: { title: 'Starry Night', artist: 'Joe Satriani', album: 'Strange Beautiful Music' },
  },
  {
    url: '/music/Kanye West - Niggas In Paris.mp3',
    duration: 219.816,
    metaData: { title: 'Niggas in Paris', artist: 'Jay-Z & Kanye West', album: 'Watch the Throne' },
  },
  {
    url: '/music/Lamb of God - Pathetic.mp3',
    duration: 272.712,
    metaData: { title: 'Pathetic', artist: 'Lamb of God', album: 'Sacrament' },
  },
  {
    url: '/music/Linkin Park - Given Up.mp3',
    duration: 189.384,
    metaData: { title: 'Given Up', artist: 'Linkin Park', album: 'Minutes to Midnight' },
  },
  {
    url: '/music/Pantera - Cemetery Gates.mp3',
    duration: 422.976,
    metaData: { title: 'Cemetery Gates', artist: 'Pantera', album: 'Hellbound' },
  },
  {
    url: '/music/Paramore - Careful.mp3',
    duration: 236.424,
    metaData: { title: 'Careful', artist: 'Paramore', album: 'Careful' },
  },
  {
    url: '/music/Periphery - Luck As A Constant.mp3',
    duration: 364.944,
    metaData: { title: 'Luck as a Constant', artist: 'Periphery', album: "Periphery II: This Time It's Personal" },
  },
  {
    url: '/music/Pikotaro - PPAP.mp3',
    duration: 124.896,
    metaData: { title: 'PPAP (Pen Pineapple Apple Pen)', artist: 'PIKOTARO', album: 'PPAP' },
  },
  {
    url: '/music/Psy - Gangnam Style.mp3',
    duration: 219.528,
    metaData: { title: 'Gangnam Style', artist: 'PSY', album: 'Gangnam Style' },
  },
  {
    url: '/music/Slipknot - Surfacing.mp3',
    duration: 218.112,
    metaData: { title: 'Surfacing', artist: 'Slipknot', album: 'Antennas to Hell' },
  },
  {
    url: '/music/Midu Shange - Folk Song.mp3',
    duration: 213.216,
    metaData: { title: '弥渡山歌 (1.2加速版)', artist: '山丹丹民歌组合', album: '弥渡山歌' },
  },
];
